import React, { Component } from 'react'
import {
    Alert,
    Grid,
    Box,
    Tabs,
    FormControl,
    FormControlLabel,
    Checkbox,
    TextField,
    LinearProgress,
    Tooltip,
    Select,
    MenuItem,
    ListSubheader,
    FormHelperText,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import DefFieldSettings from './DefFieldSettings/DefFieldSettings'

import { faExclamationCircle } from '@fortawesome/pro-duotone-svg-icons/faExclamationCircle'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'
import { faClone } from '@fortawesome/pro-duotone-svg-icons/faClone'
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons/faInfoCircle'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ObjectCreatedInfo from '../Elements/ObjectCreatedInfo'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { StyledVerticalTab } from '@/Components/Elements/StyledComponents/Tabs'
import TabPanel from '@/Components/Elements/TabPanel/TabPanel'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
import { listSubheaderProps } from '@/Components/Elements/StyledComponents/styles'

const OuterContainer = styled('div')({
    userSelect: 'none',
})

const InnerScroll = styled('div')({
    maxHeight: 150,
    overflowY: 'auto',
})

class DefFieldForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            baseFields: [],
            dataFields: [],
            defDossier: this.props.defDossier,
            defFieldLists: [],
            defDossierUsedBy: [],
            errors: null,
            infoItem: null,
            item: this.props.item
                ? {
                      id: this.props.item.id,
                      name: this.props.item.name,
                      type: this.props.item.type,
                      settings: this.props.item.settings
                          ? this.props.item.settings
                          : {},
                      ranks: [],
                  }
                : {
                      settings: {},
                  },
            submitting: false,
            duplicate: false,
            defFieldsSubmitting: false,
            defFieldsUpdated: [],
            defFieldsDone: 0,
            keypressCheckbox: false,
            activeTab: 'general',
        }

        this.handleErrors = this.handleErrors.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onSettingsChange = this.onSettingsChange.bind(this)
        this.onRankChange = this.onRankChange.bind(this)
        this.onChangeSettings = this.onChangeSettings.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.submitBaseField = this.submitBaseField.bind(this)
        this.getUsedBaseFields = this.getUsedBaseFields.bind(this)
        this.checkUsed = this.checkUsed.bind(this)
        this.duplicateFieldsModal = this.duplicateFieldsModal.bind(this)
        this.handleChecked = this.handleChecked.bind(this)
        this.updateDefFields = this.updateDefFields.bind(this)
    }

    /**
     * @param response
     * @returns {boolean}
     */
    hasFormErrors(response) {
        if (
            response.response.status === 400 &&
            response.response.data &&
            response.response.data.errors
        ) {
            return true
        }

        return false
    }

    handleSuccess() {
        this.setState({
            submitting: false,
            item: {},
            errors: false,
        })

        this.props.onClose(true)
    }

    handleErrors(response) {
        if (!this.hasFormErrors(response)) {
            this.setState({
                submitting: false,
                errors: {
                    generic: this.props.kedo.t('Something went wrong'),
                },
            })
        }
        this.setState({
            submitting: false,
            errors: response.response.data.errors,
        })
    }

    renderErrorFeedback(errorMsg) {
        if (!errorMsg) {
            return
        }

        return <FormHelperText error>{errorMsg}</FormHelperText>
    }

    handleCheck(event) {
        let item = this.state.item
        item[event.target.name] = event.target.checked
        this.setState({ item: item })
    }

    onSettingsChange(name, value) {
        let item = this.state.item
        if (!item.settings) {
            item.settings = { [name]: value }
        }
        item.settings[name] = value
        this.setState({ item: item })
    }
    onRankChange(items) {
        let ranks = items.map((item) => {
            return {
                uuid: item.uuid,
                id: item.id,
                rank: item.rank,
            }
        })
        this.setState({ items_ranks: ranks })
    }
    onChangeSettings(event) {
        let item = this.state.item
        item.settings[event.target.name] = event.target.value
        this.setState({ item: item })
    }

    handleChange(event) {
        let item = this.state.item
        item[event.target.name] = event.target.value
        this.setState({ item: item })
    }

    submitBaseField(duplicateItem = null) {
        const kedo = this.props.kedo

        if (!this.state.item.name || !this.state.item.type) {
            let errors = {}
            if (!this.state.item.name || this.state.item.name.length <= 0) {
                errors.name = kedo.t('This is a required field')
            }
            if (!this.state.item.type || this.state.item.type.length <= 0) {
                errors.type = kedo.t('This is a required field')
            }

            this.setState({ errors: errors })
            return
        }

        if (duplicateItem) {
            this.setState({
                submitting: true,
                errors: false,
            })
        } else {
            this.setState({
                submitting: duplicateItem ? false : true,
                errors: false,
            })
        }

        let item = {
            name: duplicateItem?.name || this.state.item.name,
            settings: duplicateItem?.settings || this.state.item.settings,
        }

        if (this.props.item.id && !this.state.duplicate) {
            kedo.api()
                .patch(
                    kedo.api().getDefFieldEndpoint() + '/' + this.props.item.id,
                    item
                )
                .then((successResponse) => this.handleSuccess())
                .catch((errResponse) => this.handleErrors(errResponse))
            if (this.state.items_ranks) {
                this.state.items_ranks.forEach((item) => {
                    kedo.api().patch(
                        kedo.api().getDefFieldListEndpoint() + '/' + item.id,
                        {
                            rank: item.rank,
                        }
                    )
                })
            }
        } else {
            item.environment = kedo.env().getEnvironment().id
            item.type = this.state.item.type || duplicateItem?.type
            item.uuid = kedo.utils().uuidv4()

            return kedo
                .api()
                .post(kedo.api().getDefFieldEndpoint(), item)
                .then((successResponse) => {
                    this.handleSuccess()
                    if (duplicateItem) {
                        return successResponse.data
                    }
                })
                .catch((errResponse) => this.handleErrors(errResponse))
        }
    }

    getBaseFieldInfo() {
        const kedo = this.props.kedo

        kedo.api()
            .get(kedo.api().getDefFieldEndpoint(this.props.item.id))
            .then((response) => {
                this.setState({ infoItem: response.data })
            })
    }

    getUsedBaseFields() {
        const kedo = this.props.kedo
        let defDossiers = kedo.env().getCurrentEnvironmentDefDossiers()
        let defDossierDefFields = []

        const requests = defDossiers.map((item) => {
            return kedo
                .api()
                .get(kedo.api().getDefDossierDefFieldEndpoint(), {
                    params: {
                        defDossier: item.id,
                    },
                })
                .then((successResponse) =>
                    defDossierDefFields.push(...successResponse.data.results)
                )
        })

        Promise.all(requests).then(() => {
            let found = defDossierDefFields.filter(
                (item) => item?.def_field?.id == this.props.item.id
            )
            this.setState({ defDossierUsedBy: found })
        })
    }

    componentDidMount() {
        if (this.props?.item?.id) {
            this.getUsedBaseFields()
            this.getBaseFieldInfo()
            document.addEventListener('keyup', (e) => {
                if (e.key === 'Shift') {
                    this.setState({ keypressCheckbox: false })
                }
            })
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Shift') {
                    this.setState({ keypressCheckbox: true })
                }
            })
        }
    }

    checkUsed() {
        if (this.props.checkUsed && this.props.checkUsed())
            return this.props.checkUsed()

        if (this.state.defDossierUsedBy?.length > 0) return true

        return false
    }

    async updateDefFields() {
        const kedo = this.props.kedo

        const name = `${this.props?.item?.name.split('#')[0].trim()} #${
            this.props?.item?.name.includes('#')
                ? parseInt(this.props?.item?.name.split('#')[1]) + 1
                : 1
        }`
        const baseField = await this.submitBaseField({
            name: name,
            type: this.props?.item?.type,
            settings: this.props?.item?.settings,
        })

        if (
            this.props?.item?.type === 'list' &&
            this.props?.item?.def_field_lists.length > 0
        ) {
            const requests = this.props.item.def_field_lists.map((item) => {
                delete item.def_field_id
                delete item.id
                delete item.uuid

                return kedo.api().post(kedo.api().getDefFieldListEndpoint(), {
                    ...item,
                    defField: baseField.id,
                    environment: kedo.env().getEnvironmentId(),
                })
            })

            Promise.all(requests)
        }

        if (baseField !== null) {
            if (this.state.defFieldsUpdated?.length > 0) {
                this.setState({ defFieldsSubmitting: true })

                const requests = this.state.defFieldsUpdated.map((item) => {
                    delete item.def_field

                    return kedo
                        .api()
                        .put(
                            kedo.api().getDefDossierDefFieldEndpoint(item.id),
                            {
                                ...item,
                                defField: baseField.id,
                            }
                        )
                        .then((successResponse) =>
                            this.setState({
                                defFieldsDone: this.state.defFieldsDone + 1,
                            })
                        )
                })

                Promise.all(requests).then((result) => {
                    this.setState(
                        { defFieldsSubmitting: false, defFieldsSuccess: true },
                        () => setTimeout(() => this.handleSuccess(), 600)
                    )
                })
            } else {
                this.setState(
                    { defFieldsSubmitting: false, defFieldsSuccess: true },
                    () => setTimeout(() => this.handleSuccess(), 600)
                )
            }
        }
    }

    handleChecked = (e, item) => {
        if (e.type === 'mouseover' && !this.state.keypressCheckbox) return null

        let defFieldsUpdated = this.state.defFieldsUpdated

        defFieldsUpdated = defFieldsUpdated.filter(
            (field) => field.id !== item.id
        )

        if (e.type === 'mouseover') {
            e.target.checked = !e.target.checked
        }

        if (e.target.checked) {
            defFieldsUpdated.push(item)
        }

        this.setState({ defFieldsUpdated: defFieldsUpdated })
    }

    duplicateFieldsModal() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'sm'}
                fullWidth
                title={
                    <>
                        {' '}
                        {this.props.kedo.t('Duplicate')}{' '}
                        {this.props.kedo.t('Base field').toLowerCase()}:{' '}
                        {this.props.item.id
                            ? this.state.item.name
                            : this.props.kedo.t('Unknown')}
                    </>
                }
                onClose={(event, reason) => {
                    if (reason === 'backdropClick') return
                    this.setState({ duplicate: !this.state.duplicate })
                }}
                headerClose={() =>
                    this.setState({ duplicate: !this.state.duplicate })
                }
                contentProps={{ dividers: true }}
                actions={
                    <>
                        <StyledButton onClick={() => this.updateDefFields()}>
                            {this.state.defFieldsSubmitting ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            &nbsp; {this.props.kedo.t('Continue')}
                        </StyledButton>
                        <StyledButton
                            onClick={() =>
                                this.setState({
                                    duplicate: !this.state.duplicate,
                                })
                            }
                            color="secondary"
                        >
                            {this.props.kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
                PaperProps={{
                    sx: {
                        overflow: 'hidden',
                    },
                }}
            >
                <Box>
                    {this.state.defFieldsSuccess ? (
                        <Alert severity={'success'}>
                            {this.props.kedo.t('Item has been saved')}
                        </Alert>
                    ) : null}
                    {this.state.defDossierUsedBy?.length > 0 ? (
                        <>
                            <p>
                                {this.props.kedo.t('duplicate_transfer_fields')}
                            </p>
                            <OuterContainer className="unselectable">
                                <InnerScroll>
                                    {[...this.state.defDossierUsedBy]
                                        .sort((a, b) =>
                                            a?.def_dossier_id ===
                                            this.props.defDossier
                                                ? -1
                                                : b?.def_dossier_id ===
                                                  this.props.defDossier
                                                ? 1
                                                : a?.def_dossier_id >
                                                  b?.def_dossier_id
                                                ? 1
                                                : -1
                                        )
                                        .map((item, index) => {
                                            const defDossier = this.props.kedo
                                                .env()
                                                .getDefDossierById(
                                                    item?.def_dossier_id
                                                )

                                            return (
                                                <FormControlLabel
                                                    key={index}
                                                    sx={{
                                                        width: '100%',
                                                        m: 0,
                                                        fontSize: '0.875rem',
                                                    }}
                                                    control={
                                                        <Checkbox
                                                            size="small"
                                                            onChange={(e) =>
                                                                this.handleChecked(
                                                                    e,
                                                                    item
                                                                )
                                                            }
                                                            onMouseOver={(e) =>
                                                                this.handleChecked(
                                                                    e,
                                                                    item
                                                                )
                                                            }
                                                        />
                                                    }
                                                    label={
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                                width: '100%',
                                                                gap: 0.5,
                                                                margin: 0,
                                                            }}
                                                        >
                                                            <span>
                                                                {item?.name}{' '}
                                                                {this.props
                                                                    .defDossier ===
                                                                    item?.def_dossier_id && (
                                                                    <>
                                                                        (
                                                                        <b>
                                                                            {this.props.kedo.t(
                                                                                'Current'
                                                                            )}
                                                                        </b>
                                                                        )
                                                                    </>
                                                                )}
                                                            </span>

                                                            <Tooltip
                                                                title={this.props.kedo
                                                                    .env()
                                                                    .translateItem(
                                                                        defDossier,
                                                                        'defdossier'
                                                                    )}
                                                                placement="top"
                                                            >
                                                                <FontAwesomeIcon
                                                                    icon={
                                                                        faInfoCircle
                                                                    }
                                                                />
                                                            </Tooltip>
                                                        </Box>
                                                    }
                                                />
                                            )
                                        })}
                                </InnerScroll>
                            </OuterContainer>
                            {this.state.defFieldsSubmitting ? (
                                <Box sx={{ width: '100%', mt: 1 }}>
                                    <LinearProgress
                                        variant="determinate"
                                        value={
                                            (this.state.defFieldsDone /
                                                this.state.defFieldsUpdated
                                                    .length) *
                                            100
                                        }
                                    />
                                </Box>
                            ) : null}
                        </>
                    ) : null}
                </Box>
            </AppDialog>
        )
    }

    render() {
        const kedo = this.props.kedo

        return (
            <>
                {this.state.duplicate ? this.duplicateFieldsModal() : null}

                <AppDialog
                    aria-labelledby="contained-modal-title-vcenter"
                    open
                    maxWidth={'md'}
                    fullWidth
                    title={
                        <>
                            {kedo.t(this.props.item.id ? 'Edit' : 'Add')}{' '}
                            {kedo.t('Base field').toLowerCase()}:{' '}
                            {this.props.item.id
                                ? this.state.item.name
                                : this.props.kedo.t('Unknown')}
                        </>
                    }
                    onClose={() => this.props.onClose()}
                    headerClose={() => this.props.onClose()}
                    contentProps={{ dividers: true, dense: true }}
                    actions={
                        <>
                            {this.props.item.id ? (
                                <Box sx={{ mr: 'auto' }}>
                                    <StyledButton
                                        disabled={this.checkUsed()}
                                        onClick={() =>
                                            this.props.onDelete(this.props.item)
                                        }
                                        color="error"
                                        title={
                                            this.checkUsed()
                                                ? this.props.kedo.t(
                                                      'You cannot delete a placed field'
                                                  )
                                                : this.props.kedo.t('Delete')
                                        }
                                    >
                                        <FontAwesomeIcon icon={faTrashAlt} />
                                        &nbsp; {this.props.kedo.t('Delete')}
                                    </StyledButton>
                                    <StyledButton
                                        sx={{ ml: 1 }}
                                        onClick={() =>
                                            this.setState({
                                                duplicate:
                                                    !this.state.duplicate,
                                            })
                                        }
                                    >
                                        <FontAwesomeIcon icon={faClone} />
                                        &nbsp; {this.props.kedo.t('Duplicate')}
                                    </StyledButton>
                                </Box>
                            ) : null}
                            <StyledButton onClick={this.submitBaseField}>
                                {this.state.submitting ? (
                                    <LoadingDefault size={'sm'} as={'span'} />
                                ) : (
                                    <FontAwesomeIcon icon={faSave} />
                                )}
                                &nbsp; {kedo.t('Save')}
                            </StyledButton>
                            <StyledButton
                                onClick={() => this.props.onClose()}
                                color="secondary"
                            >
                                {kedo.t('Cancel')}
                            </StyledButton>
                        </>
                    }
                >
                    <Grid container>
                        <Grid
                            size={3}
                            sx={{ borderRight: 1, borderColor: 'divider' }}
                        >
                            <Tabs
                                value={this.state.activeTab}
                                orientation="vertical"
                                onChange={(event, newValue) =>
                                    this.setState((prevState) => ({
                                        ...prevState,
                                        activeTab: newValue,
                                    }))
                                }
                                sx={{
                                    '& .MuiTabs-indicator': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <StyledVerticalTab
                                    label={
                                        <>
                                            {kedo.t('Generic')}
                                            {this.state.errors != null &&
                                            this.state.errors &&
                                            (this.state.errors.name ||
                                                this.state.errors.type) ? (
                                                <FontAwesomeIcon
                                                    className={`validationIcon validationFailed`}
                                                    icon={faExclamationCircle}
                                                />
                                            ) : null}
                                        </>
                                    }
                                    value="general"
                                    sx={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: 1,
                                        width: '100%',
                                        justifyContent: 'space-between',
                                    }}
                                />
                                <StyledVerticalTab
                                    label={kedo.t('Misc')}
                                    value="misc"
                                />
                                <StyledVerticalTab
                                    label={kedo.t('Info')}
                                    value="info"
                                />
                            </Tabs>
                        </Grid>
                        <Grid size={9}>
                            <TabPanel
                                value={this.state.activeTab}
                                index="general"
                            >
                                {this.checkUsed() ? (
                                    <Alert severity={'warning'}>
                                        &nbsp;{' '}
                                        {this.props.kedo.t('used_field_alert')}
                                    </Alert>
                                ) : null}
                                <h3>{kedo.t('Generic')}</h3>
                                <FormControl fullWidth margin="normal">
                                    <FormInputLabel>
                                        {kedo.t('Name')}
                                    </FormInputLabel>
                                    <TextField
                                        id="name"
                                        name="name"
                                        size="small"
                                        value={this.state.item.name}
                                        onChange={this.handleChange}
                                        error={Boolean(this.state.errors?.name)}
                                        helperText={this.state.errors?.name}
                                    />
                                </FormControl>
                                <FormControl fullWidth margin="normal">
                                    <FormInputLabel id="type-label">
                                        {kedo.t('Type')}
                                    </FormInputLabel>
                                    <Select
                                        labelId="type-label"
                                        id="type"
                                        name="type"
                                        size="small"
                                        value={this.state.item.type || ''}
                                        onChange={this.handleChange}
                                        displayEmpty
                                        MenuProps={listSubheaderProps}
                                    >
                                        <MenuItem value="">
                                            {kedo.t('Choose an option')}
                                        </MenuItem>
                                        <ListSubheader>
                                            {kedo.t('Text')}
                                        </ListSubheader>
                                        <MenuItem value="text">
                                            {kedo.t('Text')}
                                        </MenuItem>
                                        <MenuItem value="textarea">
                                            {kedo.t('Text area')}
                                        </MenuItem>
                                        <MenuItem value="amount">
                                            {kedo.t('Amount')}
                                        </MenuItem>
                                        <MenuItem value="decimal">
                                            {kedo.t('Decimal')}
                                        </MenuItem>
                                        <MenuItem value="url">URL</MenuItem>
                                        <MenuItem value="email">
                                            {kedo.t('E-mail')}
                                        </MenuItem>
                                        <MenuItem value="autoIncrement">
                                            {kedo.t('Auto increment')}
                                        </MenuItem>
                                        <MenuItem value="calc">
                                            {kedo.t('Formula')}
                                        </MenuItem>
                                        <ListSubheader>
                                            {kedo.t('Other')}
                                        </ListSubheader>
                                        <MenuItem value="imageCode">
                                            {kedo.t('Image code')}
                                        </MenuItem>
                                        <MenuItem value="date">
                                            {kedo.t('Date')}
                                        </MenuItem>
                                        <MenuItem value="time">
                                            {kedo.t('Time')}
                                        </MenuItem>
                                        <MenuItem value="file">
                                            {kedo.t('Files')}
                                        </MenuItem>
                                        <MenuItem value="geolocation">
                                            {kedo.t('Geolocation')}
                                        </MenuItem>
                                        <MenuItem value="list">
                                            {kedo.t('List')}
                                        </MenuItem>
                                        <MenuItem value="user">
                                            {kedo.t('Users')}
                                        </MenuItem>
                                        <MenuItem value="customActionButton">
                                            {kedo.t('Action button')}
                                        </MenuItem>
                                    </Select>
                                    {this.renderErrorFeedback(
                                        this.state.errors?.type
                                    )}
                                </FormControl>
                            
                            </TabPanel>
                            <TabPanel value={this.state.activeTab} index="misc">
                                <DefFieldSettings
                                    onSettingsChange={this.onSettingsChange}
                                    onRankChange={this.onRankChange}
                                    kedo={this.props.kedo}
                                    item={this.state.item}
                                />
                            </TabPanel>
                            <TabPanel
                                value={this.state.activeTab}
                                index={'info'}
                            >
                                <h3>{kedo.t('Info')}</h3>
                                {this.state.infoItem ? (
                                    <ObjectCreatedInfo
                                        kedo={kedo}
                                        item={this.state.infoItem}
                                    />
                                ) : null}
                                {this.props?.item?.id ? (
                                    <>
                                        <hr />
                                        <FormInputLabel>
                                            {kedo.t('Additional information')}
                                        </FormInputLabel>
                                        <div>{kedo.t('usage_basefield')}</div>
                                        <div
                                            style={{
                                                overflowY: 'scroll',
                                                maxHeight: '250px',
                                            }}
                                        >
                                            <table
                                                className={
                                                    'table table-striped'
                                                }
                                            >
                                                <tbody>
                                                    <tr
                                                        style={{
                                                            position: 'sticky',
                                                            top: 0,
                                                            width: '100%',
                                                            backgroundColor:
                                                                'rgba(243, 244, 247, 1)',
                                                        }}
                                                    >
                                                        <th>
                                                            {kedo.t('Entity')}
                                                        </th>
                                                        <th>
                                                            {kedo.t(
                                                                'Data field'
                                                            )}
                                                        </th>
                                                    </tr>
                                                    {this.state.defDossierUsedBy
                                                        ?.length > 0
                                                        ? [
                                                              ...this.state
                                                                  .defDossierUsedBy,
                                                          ]
                                                              .sort((a, b) => {
                                                                  return a?.def_dossier_id ===
                                                                      this.props
                                                                          .defDossier
                                                                      ? -1
                                                                      : b?.def_dossier_id ===
                                                                        this
                                                                            .props
                                                                            .defDossier
                                                                      ? 1
                                                                      : a?.def_dossier_id >
                                                                        b?.def_dossier_id
                                                                      ? 1
                                                                      : -1
                                                              })
                                                              .map(
                                                                  (
                                                                      item,
                                                                      index
                                                                  ) => {
                                                                      let defDossier =
                                                                          kedo
                                                                              .env()
                                                                              .getDefDossierById(
                                                                                  item?.def_dossier_id
                                                                              )
                                                                      let html = `${kedo
                                                                          .env()
                                                                          .translateItem(
                                                                              defDossier,
                                                                              'defdossier'
                                                                          )} ${
                                                                          this
                                                                              .props
                                                                              .defDossier ===
                                                                          item?.def_dossier_id
                                                                              ? `(<b>${kedo.t(
                                                                                    'Current'
                                                                                )}</b>)`
                                                                              : ''
                                                                      }`
                                                                      return (
                                                                          <tr
                                                                              key={index.toString()}
                                                                          >
                                                                              <td
                                                                                  dangerouslySetInnerHTML={{
                                                                                      __html: html,
                                                                                  }}
                                                                              />
                                                                              <td>
                                                                                  {
                                                                                      item?.name
                                                                                  }
                                                                              </td>
                                                                          </tr>
                                                                      )
                                                                  }
                                                              )
                                                        : null}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                ) : null}
                            </TabPanel>
                        </Grid>
                    </Grid>
                </AppDialog>
            </>
        )
    }
}

export default DefFieldForm
